import { LBTLabel, LBTSpacer, LBTImage, Section, COLORS } from '@laborability/components';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useRecoilCallback } from 'recoil';
import { handlePromoPriveSSORedirectCallback } from '@laborability/commons';
import PromoPriveLogo from '../../assets/images/promoprive.svg';
import styled from 'styled-components';

export default function PromoPrive() {
  const handlePromoPriveSSOClick = useRecoilCallback(handlePromoPriveSSORedirectCallback, []);

  // useEffect(() => {
    handlePromoPriveSSOClick();
  // }, []);

  const StyledImageContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const StyledImage = styled.img<{ maxwidth: string }>`
    width: 100%;
    max-width: ${props => props.maxwidth};
  `;

  const Image = ({ src }: { src: string }) => {
    return (
      <StyledImageContainer>
        <StyledImage src={src} maxwidth={'100%'} />
      </StyledImageContainer>
    );
  };

  return (
    <Section backgroundColor={COLORS.getInstance().WHITE}>
      <LBTSpacer spacing={8} isFixed />
      <LBTLabel variant="delaDisplay" component="h1">
        Ci siamo quasi...
      </LBTLabel>
      <LBTSpacer spacing={2} isFixed />
      <Box display="flex" justifyContent="center">
        <LBTImage image="teamWork4" size={200} />
      </Box>
      <LBTSpacer spacing={2} isFixed />
      <LBTLabel variant="spGroteskSubtitle">
        <>
        Stiamo preparando il tuo accesso.<br />
        Pochi secondi e ti portiamo automaticamente su
        </>
      </LBTLabel>
      <LBTSpacer spacing={2} isFixed />
      <Box display="flex" justifyContent="center">
        <Image src={PromoPriveLogo} />
      </Box>
      <LBTSpacer spacing={6} />
    </Section>
  );
}
